import { createVNode as _createVNode } from "vue";
/**
 * @author zhouchangluan
 * @fileoverview 弹窗
 */

import { defineComponent, toRefs } from "vue";
export default defineComponent({
  name: "PreviewDialog",
  props: {
    visible: {
      type: Boolean,
      required: false,
      default: false
    },
    // eslint-disable-next-line vue/prop-name-casing
    "onUpdate:visible": {
      type: Function,
      default: () => {}
    }
  },
  emits: ["update:visible", "close"],
  setup(props, {
    emit,
    slots
  }) {
    const {
      visible
    } = toRefs(props);
    /**
     * 事件 - 关闭弹窗
     */
    function closeDialog() {
      emit("close");
      emit("update:visible", false);
    }
    return () => {
      const closeBtnEle = slots !== null && slots !== void 0 && slots.closeBtn ? slots === null || slots === void 0 ? void 0 : slots.closeBtn() : _createVNode("div", {
        "class": "close-btn",
        "onClick": closeDialog
      }, null);
      return visible.value && (window.screen.width < 1200 ? _createVNode("div", {
        "class": "m-dialog"
      }, [_createVNode("div", {
        "class": "mask"
      }, null), _createVNode("div", {
        "class": "dialog-body"
      }, [slots === null || slots === void 0 ? void 0 : slots.default(), closeBtnEle])]) : _createVNode("div", {
        "class": "pc-dialog pc-explain"
      }, [_createVNode("div", {
        "class": "mask"
      }, null), _createVNode("div", {
        "class": "dialog-body"
      }, [slots === null || slots === void 0 ? void 0 : slots.default(), closeBtnEle])]));
    };
  }
});